import { motion } from 'framer-motion';

const MAP_IMAGE = 'https://customer-assets.emergentagent.com/job_fort-build-uk/artifacts/ugq9v76l_IMAGENS%20PARA%20SITE%20%20%282%29.png';

const UKMap = ({ className = '' }) => {
  return (
    <motion.div
      className={`relative ${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* Map Image */}
      <img 
        src={MAP_IMAGE} 
        alt="UK Coverage Map" 
        className="w-full h-auto max-w-md mx-auto"
      />
      
      {/* Animated dots overlay */}
      <svg 
        className="absolute inset-0 w-full h-full pointer-events-none"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="0.5" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>

        {/* Coverage Dots - positioned relative to the map */}
        {[
          { cx: 62, cy: 72, label: 'London', delay: 0.5, isHQ: true },
          { cx: 48, cy: 55, label: 'Birmingham', delay: 0.6 },
          { cx: 42, cy: 40, label: 'Manchester', delay: 0.7 },
          { cx: 46, cy: 38, label: 'Leeds', delay: 0.75 },
          { cx: 38, cy: 42, label: 'Liverpool', delay: 0.8 },
          { cx: 50, cy: 28, label: 'Newcastle', delay: 0.85 },
          { cx: 52, cy: 65, label: 'Bristol', delay: 0.9 },
          { cx: 38, cy: 60, label: 'Cardiff', delay: 0.95 },
          { cx: 55, cy: 48, label: 'Nottingham', delay: 1.0 },
        ].map((city, index) => (
          <motion.g key={index}>
            <motion.circle
              cx={city.cx}
              cy={city.cy}
              r={city.isHQ ? "2" : "1.2"}
              fill="#c89e4a"
              filter="url(#glow)"
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.3, delay: city.delay }}
            />
            {city.isHQ && (
              <motion.circle
                cx={city.cx}
                cy={city.cy}
                r="3.5"
                fill="none"
                stroke="#c89e4a"
                strokeWidth="0.5"
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: [1, 1.4, 1], opacity: [0.8, 0.2, 0.8] }}
                transition={{ 
                  duration: 2,
                  delay: city.delay + 0.5,
                  repeat: Infinity,
                  repeatType: "loop"
                }}
              />
            )}
            <motion.circle
              cx={city.cx}
              cy={city.cy}
              r="2.5"
              fill="none"
              stroke="#c89e4a"
              strokeWidth="0.3"
              strokeOpacity="0.3"
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: [1, 1.8, 1], opacity: [0.4, 0, 0.4] }}
              transition={{ 
                duration: 2.5, 
                delay: city.delay + 0.2,
                repeat: Infinity,
                repeatType: "loop"
              }}
            />
          </motion.g>
        ))}

        {/* Connection Lines */}
        <motion.g opacity="0.2">
          {[
            { from: { x: 62, y: 72 }, to: { x: 48, y: 55 } },
            { from: { x: 48, y: 55 }, to: { x: 42, y: 40 } },
            { from: { x: 42, y: 40 }, to: { x: 46, y: 38 } },
            { from: { x: 46, y: 38 }, to: { x: 50, y: 28 } },
            { from: { x: 48, y: 55 }, to: { x: 52, y: 65 } },
          ].map((line, index) => (
            <motion.line
              key={index}
              x1={line.from.x}
              y1={line.from.y}
              x2={line.to.x}
              y2={line.to.y}
              stroke="#c89e4a"
              strokeWidth="0.3"
              strokeDasharray="1 1"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.5, delay: 1.2 + index * 0.15 }}
            />
          ))}
        </motion.g>

        {/* HQ Label */}
        <motion.text
          x="67"
          y="73"
          fill="#c89e4a"
          fontSize="3"
          fontFamily="Alatsi, sans-serif"
          fontWeight="bold"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 1.5 }}
        >
          HQ
        </motion.text>
      </svg>
    </motion.div>
  );
};

export default UKMap;
